import React from "react";
import { Link } from "react-router-dom";
import playStoreBadge from "../../Assets/Images/get-cookandchef-on-Google-Play.png";
import appStoreBadge from "../../Assets/Images/get-cookandchef-on-Appstore.png";
import styles from "./ContentPages.module.css";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=in.cookandchef&hl=en_IN";
const APP_STORE_URL = "https://apps.apple.com/in/app/cook-and-chef/id6476929550";

const EMPLOYER_LINKS = [
  { label: "Post a Job", href: "/employer-registration" },
  { label: "Browse Chefs", href: "/cooks/chef" },
  { label: "HoReCa Solutions", href: "/horecas" },
];

const RESOURCE_LINKS = [
  { label: "Chef Salary Guide 2026", href: "/cook/chef#chef-salary-india" },
  { label: "How to Retain Chefs", href: "/horeca/restaurants" },
  { label: "House Cook Hiring Rates", href: "/cook/housecook" },
];

/**
 * Above-footer content strip: employer/resource links + app download CTAs.
 * Not part of the site footer.
 */
export default function ContentPreFooter() {
  return (
    <section className={styles.preFooter} aria-label="Employer resources and app download">
      <div className={styles.preFooterInner}>
        <div className={styles.preFooterLinks}>
          <nav className={styles.preFooterCol} aria-labelledby="prefooter-employers">
            <h2 id="prefooter-employers" className={styles.preFooterHeading}>
              For Employers
            </h2>
            <ul className={styles.preFooterList}>
              {EMPLOYER_LINKS.map((item) => (
                <li key={item.href}>
                  <Link to={item.href}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className={styles.preFooterCol} aria-labelledby="prefooter-resources">
            <h2 id="prefooter-resources" className={styles.preFooterHeading}>
              Resources &amp; Guides
            </h2>
            <ul className={styles.preFooterList}>
              {RESOURCE_LINKS.map((item) => (
                <li key={item.href + item.label}>
                  <Link to={item.href}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <aside className={styles.appDownloadCard} aria-labelledby="app-download-title">
          <h2 id="app-download-title" className={styles.appDownloadTitle}>
            Lakhs of cooks and employers are on the CookandChef app.
          </h2>
          <p className={styles.appDownloadSubtext}>Get real-time job updates &amp; more!</p>
          <div className={styles.appBadgeRow}>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.appBadgeLink}
            >
              <img
                src={playStoreBadge}
                alt="Get CookandChef on Google Play"
                className={styles.appBadge}
                loading="lazy"
              />
            </a>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.appBadgeLink}
            >
              <img
                src={appStoreBadge}
                alt="Download CookandChef on the App Store"
                className={styles.appBadge}
                loading="lazy"
              />
            </a>
          </div>
        </aside>
      </div>
    </section>
  );
}
